import React from "react";
import Header from "../../../../Components/Header";
import { Helmet } from "react-helmet";
import AddPaymentEntry from "./AddPaymentEntry";

function PaymentEntry() {
  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      <Helmet>
        <title>New Payment Entry</title>
      </Helmet>
      <Header />
      <div
        className="container-fluid maindiv d-flex flex-column "
        style={{ flexGrow: "1" }}
      >
        <AddPaymentEntry />
      </div>
    </div>
  );
}

export default PaymentEntry;